import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Types for our user profiles
export interface UserProfile {
  id: string
  user_type: 'professional' | 'regular'
  display_name: string
  business_name?: string
  bio?: string
  location?: string
  phone?: string
  website?: string
  profile_image_url?: string
  is_verified: boolean
  created_at: string
  updated_at: string
}

export interface PublicProfile {
  id: string
  user_type: 'professional' | 'regular'
  display_name: string
  business_name?: string
  bio?: string
  location?: string
  profile_image_url?: string
  is_verified: boolean
  created_at: string
}